<div class="card mb-2 article-card">
  <div class="text-decoration-none text-dark">
    <div class="position-relative">
      <div class="image-wrapper position-relative">
        <img
          [src]="spaInfo.banners"
          [alt]="spaInfo.name"
          class="img-fluid rounded"
        />
      </div>

      <div class="text-start content-container">
        <div class="content-inner">
          @for (item of spaInfo?.offers; track $index; let isLast = $last) {
          <div class="offer-item">
            <h6 class="title" [title]="item.title">
              {{ item.title | slice : 0 : 30
              }}{{ item.title.length > 30 ? "..." : "" }}
            </h6>
            <div class="timing d-flex align-items-center gap-1">
              <i class="fa fa-clock"></i> {{ item.timing }}
            </div>
          </div>

          @if (!isLast) {
          <div class="divider-vertical mx-3"></div>
          } }
        </div>
      </div>
    </div>
  </div>
</div>
